import React, { useState, useMemo, useEffect, useRef } from "react";
import TextFilterInput from "../components/TextFilterInput";
import CurrencyInput from "../components/CurrencyInput";

import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { format, parseISO } from "date-fns";
import { Col, Row, Dropdown, Button, Offcanvas } from "react-bootstrap";
import { FaEquals, FaNotEqual, FaChevronDown, FaChevronUp, FaTimes, FaArrowLeft, FaMinus, FaLongArrowAltUp, FaLongArrowAltDown, FaFlag, FaRegFlag, FaCog } from "react-icons/fa";
//import { ReactComponent as ArrowTurnLeftDown } from "../assets/svg/arrow-turn-left-down.svg";
import ArrowTurnLeftDown from "../assets/svg/arrow-turn-left-down.svg?react";

import { useToast } from "../Context/useToast";

import Checkbox from "../components/Checkbox";
import HeaderCheckbox from "../components/HeaderCheckbox";
import FollowUpModal from "../components/FollowUp";

import useFetchData from "../components/useFetchDatav2";
import ReconcileLineDetailPanel from "../components/ReconcileLineDetailPanel";
import prettyBytes from "pretty-bytes";
import ProgressBar from "../components/ProgressBar";
import Select from "react-select";
import ReconcileDropdownMenu from "../components/ReconcileDropDownMenu";
import ReconcileInvoiceStatementPdfModal from "../components/ReconcileInvoiceStatementPdfModal";
import ReconcileInvoiceStatementAuditModal from "../components/ReconcileInvoiceStatementAuditModal";
import PdfModal from "../components/PdfModal";
import LoadingIndicator from "../components/LoadingIndicator";
import useDelayedLoading from "../components/useDelayedLoading";
import { DayPicker } from "react-day-picker";
import "../css/dayPickerStyle.css";
import "./Reconcile.css";
import Sticky from "react-stickynode";

import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
   cardBody: {
      "& span": {
         fontSize: "22px !important",
         "@media (max-width: 5000px)": {
            fontSize: "22px !important",
         },
         "@media (max-width: 1800px)": {
            fontSize: "20px !important",
         },
         "@media (max-width: 1300px)": {
            fontSize: "18px !important",
         },
         "@media (max-width: 992px)": {
            fontSize: "16px !important",
         },
         "@media (max-width: 768px)": {
            fontSize: "14px !important",
         },
         "@media (max-width: 576px)": {
            fontSize: "14px !important",
         },
      },
      "&.shrink-card span": {
         //when shrunk
         fontSize: "18px !important",
         "@media (max-width: 5000px)": { fontSize: "18px !important" },
         "@media (max-width: 1800px)": { fontSize: "16px !important" },
         "@media (max-width: 1300px)": { fontSize: "14px !important" },
         "@media (max-width: 992px)": { fontSize: "12px !important" },
         "@media (max-width: 768px)": { fontSize: "12px !important" },
         "@media (max-width: 576px)": { fontSize: "12px !important" },
      },
   },
});

const styles = {
   w40: {
      width: "40px",
      maxWidth: "40px",
      minWidth: "40px",
   },
   w50: {
      width: "50px",
      maxWidth: "50px",
      minWidth: "50px",
   },
   w60: {
      width: "60px",
      maxWidth: "60px",
      minWidth: "60px",
   },
   w90: {
      width: "90px",
      maxWidth: "90px",
      minWidth: "80px",
   },
   w100: {
      width: "100px",
      maxWidth: "100px",
      minWidth: "90px",
   },
   w120: {
      width: "120px",
      maxWidth: "120px",
      minWidth: "110px",
   },
   w150: {
      width: "150px",
      maxWidth: "150px",
      minWidth: "150px",
   },
   headerActions: {
      width: "90px",
      maxWidth: "90px",
      minWidth: "70px",
   },
   w175: {
      width: "175px",
      maxWidth: "175px",
      minWidth: "150px",
   },
   w190: {
      width: "190px",
      maxWidth: "190px",
      minWidth: "180px",
   },
   w200: {
      width: "200px",
      maxWidth: "200px",
      minWidth: "175px",
   },
   defaultCell: {
      borderBottom: "1px solid #dee2e6",
      position: "relative",
   },
   redBorder: {
      backgroundColor: "rgb(255 165 0 / 10%)",
   },

   col90: { width: "90px", minWidth: "90px", maxWidth: "90px" },
   col150: { width: "150px", minWidth: "150px", maxWidth: "150px" },
   col130: { width: "130px", minWidth: "130px", maxWidth: "130px" },
   col175: { width: "175px", minWidth: "175px", maxWidth: "175px" },
};

const TableSettingDropdown = ({ showTableDropdown, handleTableToggleDropdown, handleExport, handleTableDropdownCancelChanges, filteredData }) => {
   return (
      <Dropdown show={showTableDropdown} onToggle={handleTableToggleDropdown}>
         <Dropdown.Toggle as="span" variant="link" id="dropdown-table-columns" style={{ cursor: "pointer" }}>
            <FaCog />
         </Dropdown.Toggle>
         <Dropdown.Menu className="dropdown-table-columns-width" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex justify-content-center p-2">
               <Button variant="secondary" size="sm" onClick={handleTableDropdownCancelChanges}>
                  Cancel
               </Button>
               <Button variant="primary" size="sm" onClick={handleExport} className="ms-2" disabled={filteredData.length === 0}>
                  Export
               </Button>
            </div>
         </Dropdown.Menu>
      </Dropdown>
   );
};
export default function Reconcile() {
   const [isLoading, setIsLoading] = useState(true);
   const [loadingState, setLoadingState] = useState("loading");
   const showSpinner = useDelayedLoading(isLoading);
   const [pdfLoading, setPdfLoading] = useState(false);
   const [error, setError] = useState(null);
   const [docId, setDocId] = useState(null);
   const [docName, setDocName] = useState(null);
   const [payloadRecon, setPayloadRecon] = useState([]);

   const [isSticky, setIsSticky] = useState(false);
   const [isShrunk, setIsShrunk] = useState(false);
   const handleStickyStateChange = (status) => {
      setIsSticky(status.status === Sticky.STATUS_FIXED);
   };

   const [filteredReconIndex, setFilteredReconIndex] = useState(null); //index for filtered rows for the offcanvas next/prev

   const [originalPageNumber, setOriginalPageNumber] = useState(null);
   const [showFollowup, setShowFollowup] = useState(false); //for followup offcanvas
   const [showAudit, setShowAudit] = useState(false); //for followup offcanvas
   const [followUpSupplierDetailID, setFollowUpSupplierDetailID] = useState(null);
   const [followUpExternalSourceHeaderID, setFollowUpExternalSourceHeaderID] = useState(null);
   const [followUpSupplierInvoiceNumber, setFollowUpSupplierInvoiceNumber] = useState("");
   const [followUpExternalInvoiceNumber, setFollowUpExternalInvoiceNumber] = useState("");

   const [auditFilteredRow, setAuditFilteredRow] = useState(null);

   const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] = useState(false);
   const [hoveredIndex, setHoveredIndex] = useState(null);
   const [isExpandedReconcileSummary, setIsExpandedReconcileSummary] = useState(false);
   const [expandedRowKey, setExpandedRowKey] = useState(null); // rowKey of the single open row, or null
   const [rowDetail, setRowDetail] = useState({}); // rowKey -> { status: "loading"|"loaded"|"empty"|"error", data, error }
   const [showReconcileInvoiceStatementModal, setshowReconcileInvoiceStatementModal] = useState(false);
   const [showStatementPdfModal, setShowStatementPdfModal] = useState(false);
   const [normalizedVertices, setNormalizedVertices] = useState(null);
   const [pdfPageNo, setPdfPageNo] = useState(null);
   const [invoiceStatementIsEdit, setInvoiceStatementIsEdit] = useState(false);
   const validRecons = payloadRecon.filter((recon) => !recon.isError);
   const [selectedFilter, setSelectedFilter] = useState("ALL");
   const [hideIgnored, setHideIgnored] = useState(false); // tracks show or hide ignored lines
   const [imageData, setImageData] = useState(null);
   //Filters
   const [isReadOnlyFilters, setIsReadOnlyFilters] = useState(false);
   const [supplierInvoiceNumberFilter, setSupplierInvoiceNumberFilter] = useState("");
   const [supplierInvoiceDateFilter, setSupplierInvoiceDateFilter] = useState("");
   const [showSupplierDateCalendar, setShowSupplierDateCalendar] = useState(false);
   const supplierDatePickerRef = useRef(null);

   const [supplierInvoicePoNoFilter, setSupplierInvoicePoNoFilter] = useState("");
   const [supplierInvoiceAmountFilter, setSupplierInvoiceAmountFilter] = useState("");
   const [entryInvoiceNumberFilter, setEntryInvoiceNumberFilter] = useState("");
   const [entryInvoiceDateFilter, setEntryInvoiceDateFilter] = useState("");
   const [showEntryDateCalendar, setShowEntryDateCalendar] = useState(false);
   const entryDatePickerRef = useRef(null);
   const [entryInvoiceAmountFilter, setEntryInvoiceAmountFilter] = useState("");

   const [sortColumn, setSortColumn] = useState(null);
   const [sortOrder, setSortOrder] = useState("asc");

   const { triggerToast } = useToast();
   const { fetchData } = useFetchData();

   const classes = useStyles();

   const [showTableDropdown, setShowTableDropdown] = useState(false);

   const navigate = useNavigate();
   const location = useLocation();
   const [searchParams] = useSearchParams();
   // Retrieve the passed state. The in-app entry path (location.state) is the primary
   // source; the URL query params are a fallback for cold deep-links from report drill-downs.
   const selectedInvoiceStatement = location.state?.selectedInvoiceStatement || searchParams.get("stmt");
   const focusLineId = searchParams.get("line"); // == row.sd_id (sup_state_detail_external_id)
   const focusErpId = searchParams.get("erp"); // == row.en_id (esh_external_id)
   // Header values from the loaded reconcile response, used when location.state is absent
   // (cold deep-link). The reconcile response carries the statement date (s_date) but not
   // the supplier name, so the name falls back to a neutral placeholder.
   const [responseStatementName, setResponseStatementName] = useState(null);
   const [responseStatementDate, setResponseStatementDate] = useState(null);
   const selectedInvoiceStatementName = location.state?.selectedInvoiceStatementSupplierName ?? responseStatementName ?? "Statement";
   const selectedInvoiceStatementDate = location.state?.selectedInvoiceStatementDate ?? responseStatementDate ?? "";
   const selectedInvoiceStatementGrade = location.state?.selectedInvoiceStatementGrade;
   const selectedInvoiceStatementDpaId = location.state?.selectedInvoiceStatementDpaId;
   const [documentGrade, setDocumentGrade] = useState(selectedInvoiceStatementGrade || "-");
   const [summaryMatchedCount, setSummaryMatchedCount] = useState(null);
   const [summaryInvoiceLineCount, setSummaryInvoiceLineCount] = useState(null);

   // Function to parse user-entered date (fallback when typing manually)
   const parseDate = (input) => {
      const parts = input.split("-");
      if (parts.length === 3) {
         const date = new Date(parts[0], parts[1] - 1, parts[2]);
         return isNaN(date.getTime()) ? null : date;
      }
      return null;
   };

   const formatDateInputValue = (value) => {
      if (value instanceof Date) return format(value, "yyyy-MM-dd");
      return value || "";
   };

   useEffect(() => {
      const handleClickOutside = (event) => {
         if (supplierDatePickerRef.current && !supplierDatePickerRef.current.contains(event.target)) {
            setShowSupplierDateCalendar(false);
         }
         if (entryDatePickerRef.current && !entryDatePickerRef.current.contains(event.target)) {
            setShowEntryDateCalendar(false);
         }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
   }, []);

   const handleExport = () => {
      exportToCSV(); // call your existing exportToCSV function
      setShowTableDropdown(false); // close dropdown after export click
   };
   const handleTableDropdownCancelChanges = () => {
      setShowTableDropdown(false); // Close dropdown on apply
   };
   const handleTableToggleDropdown = (isOpen) => {
      setShowTableDropdown(isOpen);
   };

   const matched_options = [
      { value: "ALL", label: "All" },
      { value: "MATCHED", label: "Matched" },
      { value: "PARTIAL", label: "Partially Matched" },
      { value: "UNMATCHED", label: "Unmatched" },
      { value: "NO_ERP", label: "No Invoice" },
      { value: "DIVIDER", label: "────────────", isDisabled: true },
      { value: "KEYING_ISSUE", label: "Keying Issues" },
      { value: "OVER_ALLOCATED", label: "Over Allocated" },
      { value: "IGNORE", label: `${hideIgnored ? "Show" : "Hide"} Ignored Lines` },
   ];

   useEffect(() => {
      // this useEffect gets the invoice statement and invoices
      const getInvoiceStatementRecon = async () => {
         if (!selectedInvoiceStatement) return;
         setIsLoading(true);
         const url = "/getInvStatementReconcile.sz";
         const method = "POST";
         const formData = new FormData();
         formData.append("_inv_stat_id", selectedInvoiceStatement);

         try {
            const { responseData, fetchLoading, fetchError } = await fetchData(url, method, formData, "form-data");
            if (responseData.st === 1) {
               const gradeFromResponse =
                  responseData?.document_grade ||
                  responseData?.grade ||
                  responseData?.payload?.[0]?.document_grade ||
                  responseData?.payload?.[0]?.grade ||
                  responseData?.payload?.[0]?.dpa_confidence_breakdown?.grade;

               if (gradeFromResponse) {
                  setDocumentGrade(String(gradeFromResponse).toUpperCase());
               }

               const updatePayload = responseData.payload.map((item) => ({
                  ...item,
                  sd_id: item.sd_id ?? null,
                  en_id: item.en_id ?? null,
                  sd_ignored: item.sd_ignore ?? item.sd_ignored ?? false,
                  isChecked: false,
                  isError: false,
               }));
               setPayloadRecon(updatePayload);

               // Header fallback for cold deep-links: the reconcile response rows carry the
               // statement date (s_date) but not the supplier name. Populate what we can so
               // the header isn't blank when location.state is absent. Never crash if absent.
               const firstRow = Array.isArray(responseData.payload) ? responseData.payload[0] : null;
               if (firstRow) {
                  const respDate = firstRow.s_date ?? firstRow.statement_date ?? null;
                  if (respDate) setResponseStatementDate(String(respDate));
                  const respName = firstRow.s_name ?? firstRow.sm_name ?? firstRow.supplier ?? firstRow.supplier_name ?? null;
                  if (respName) setResponseStatementName(String(respName));
               }
            } else {
               setPayloadRecon([]);

               if (responseData.m_en) {
                  triggerToast("warning", responseData.m_en, false, "", false);
               } else {
                  triggerToast("error", "We seem to have an issue retrieving invoicing statements, please try again later.", true, "Issue", false, 0);
               }
            }
         } catch (error) {
            setPayloadRecon([]);

            triggerToast("error", "We seem to have an access your data, please try again later.", true, "Network Issue", false, 0);
         } finally {
            setIsLoading(false);
         }
      };
      getInvoiceStatementRecon();
   }, [selectedInvoiceStatement]);

   // Guards the deep-link line focus so it fires once per (statement, focus), not on every
   // rowDetail change. Reset below whenever the statement changes.
   const focusAppliedRef = useRef(null);

   // Expansion + ERP-detail cache are per-statement; reset when the statement changes.
   useEffect(() => {
      setExpandedRowKey(null);
      setRowDetail({});
      focusAppliedRef.current = null; // allow deep-link focus to re-fire for the new statement
   }, [selectedInvoiceStatement]);

   // Deep-link line focus: when a report drill-down opens this view with ?line=&erp=, once
   // the rows are loaded, expand + scroll to the targeted line.
   useEffect(() => {
      if (!focusLineId) return;
      if (!payloadRecon || payloadRecon.length === 0) return;

      const focusKey = `${selectedInvoiceStatement}|${focusLineId}|${focusErpId || ""}`;
      if (focusAppliedRef.current === focusKey) return;

      const target = payloadRecon.find((r) => (focusErpId ? r.sd_id === focusLineId && r.en_id === focusErpId : r.sd_id === focusLineId));
      if (!target) return;

      focusAppliedRef.current = focusKey;
      const rowKey = rowKeyOf(target);
      setExpandedRowKey(rowKey);
      if (!rowDetail[rowKey] && target.en_id) fetchRowDetail(rowKey, target);

      setTimeout(() => {
         document.querySelector(`[data-id="${target.sd_id}-${target.en_id}"]`)?.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 150);
   }, [focusLineId, focusErpId, payloadRecon]);

   useEffect(() => {
      if (selectedInvoiceStatementGrade) {
         setDocumentGrade(String(selectedInvoiceStatementGrade).toUpperCase());
      }
   }, [selectedInvoiceStatementGrade]);

   useEffect(() => {
      // Fetch authoritative statement summary metrics (grade + match counts).
      const fetchStatementSummary = async () => {
         if (!selectedInvoiceStatementDpaId) return;

         const url = "/getInvStatementSummary.sz";
         const method = "POST";
         const formData = new FormData();
         formData.append("_dpa_id", selectedInvoiceStatementDpaId);

         try {
            const { responseData } = await fetchData(url, method, formData, "form-data");
            if (responseData?.st === 1 && Array.isArray(responseData?.payload) && responseData.payload.length > 0) {
               const statement = responseData.payload[0]?.statement || {};
               const summaryMatch = statement?.invoice_state_match;
               const summaryLines = statement?.invoice_line_count;

               if (summaryMatch !== undefined && summaryMatch !== null) {
                  setSummaryMatchedCount(Number(summaryMatch));
               }
               if (summaryLines !== undefined && summaryLines !== null) {
                  setSummaryInvoiceLineCount(Number(summaryLines));
               }

               const normalizedCurrentGrade = String(documentGrade || "-").trim();
               const fallbackGrade = statement?.dpa_confidence_breakdown?.grade || statement?.grade;
               if (fallbackGrade && (!normalizedCurrentGrade || normalizedCurrentGrade === "-")) {
                  setDocumentGrade(String(fallbackGrade).toUpperCase());
               }
            }
         } catch (error) {
            // Intentionally silent fallback: do not impact reconcile workflow.
         }
      };

      fetchStatementSummary();
   }, [selectedInvoiceStatementDpaId, documentGrade]);

   const fetchRecons = async (filters) => {
      const url = "/getDocs.sz";
      const method = "POST";
      try {
         const { responseData, fetchLoading, fetchError } = await fetchData(url, method, filters, "form-data");
         console.log("RESPONSEDATA:", responseData);
         if (responseData.st === 1) {
            if (Array.isArray(responseData.payload)) {
               setPayloadRecon(responseData.payload);
            } else {
               console.error("Invalid data structure, payload is not an array");
            }
         } else {
            if (responseData.m_en) {
               setError(responseData.m_en);
            } else {
               setError("We seem to have an issue authenticating, please try again later.");
            }
         }
      } catch (error) {
         console.error("Error fetching data:", error);
      }
   };

   const handleToggleReconcileSummary = () => {
      setIsExpandedReconcileSummary((prev) => !prev);
   };

   const handleBackClick = () => {
      navigate("/apps/invoicestatements", {
         state: {
            selectedInvoiceStatementNav: selectedInvoiceStatement,
            selectedDocumentPartId: location.state?.selectedInvoiceStatementDpaId,
            activeSection: location.state?.activeSection,
            scrollY: location.state?.scrollY,
         },
      });
   };

   // Open statement PDF using the same viewer used in statement offcanvas.
   const handleStatementViewModal = async () => {
      if (!imageData) {
         await fetchPdfContent();
      }

      setShowStatementPdfModal(true);
      
      // Blur the button to remove focus styling
      document.getElementById("InvoiceStatementView")?.blur();
   };

   const fetchPdfContent = async () => {
      if (!selectedInvoiceStatement) return;
      setPdfLoading(true);

      const url = "/getfile.sz";
      const method = "POST";
      const formData = new FormData();
      formData.append("_inv_stat_id", selectedInvoiceStatement);

      try {
         const { responseData, fetchError } = await fetchData(url, method, formData, "form-data", "blob");

         if (fetchError) {
            triggerToast("error", "Failed to load PDF. Please try again.", true, "Error", false, 0);
            return;
         }
         // Convert Blob to URL
         //const pdfUrl = URL.createObjectURL(responseData);
         //setImageData(pdfUrl);

         // Convert Blob to Base64
         const base64Data = await convertBlobToBase64(responseData);
         setImageData(base64Data); // Store Base64 data in state
      } catch (error) {
         triggerToast("error", "Network issue, please try again.", true, "Network Issue", false, 0);
      } finally {
         setPdfLoading(false);
      }
   };

   // Helper function to convert Blob to Base64
   const convertBlobToBase64 = (blob) => {
      return new Promise((resolve, reject) => {
         const reader = new FileReader();
         reader.readAsDataURL(blob);
         reader.onloadend = () => resolve(reader.result.split(",")[1]); // Remove `data:application/pdf;base64,`
         reader.onerror = reject;
      });
   };

   const handleReconcileInvoiceStatementModalClose = () => {
      setshowReconcileInvoiceStatementModal(false);
      setIsReadOnlyFilters(false);
      setOriginalPageNumber(-1);
   };

   const handleStatementPdfModalClose = () => {
      setShowStatementPdfModal(false);
   };

   function PrettyType({ label }) {
      const formatted = label.replace(/(?!^)([A-Z])/g, " $1");
      return <span>{formatted}</span>;
   }

   const rowKeyOf = (data) => `${data?.sd_id ?? "x"}::${data?.en_id ?? "x"}`;

   const fetchRowDetail = async (rowKey, data) => {
      setRowDetail((prev) => ({ ...prev, [rowKey]: { status: "loading" } }));
      try {
         const formData = new FormData();
         formData.append("_sd_id", data.sd_id);
         formData.append("_en_id", data.en_id);
         const { responseData } = await fetchData("/getInvStateDetails.sz", "POST", formData, "form-data");

         if (responseData?.st === 0 || responseData?.st === -2) {
            triggerToast("warning", "Your session has expired, please sign in again.", true, "Session", false, 0);
            setRowDetail((prev) => ({ ...prev, [rowKey]: { status: "error", error: "session" } }));
            return;
         }
         const erp = responseData?.payload?.erp_detail;
         if (responseData?.st === 1 && erp && typeof erp === "object") {
            setRowDetail((prev) => ({ ...prev, [rowKey]: { status: "loaded", data: responseData.payload } }));
         } else {
            setRowDetail((prev) => ({ ...prev, [rowKey]: { status: "error", error: responseData?.mg || "" } }));
         }
      } catch (error) {
         console.error("getInvStateDetails failed", error);
         setRowDetail((prev) => ({ ...prev, [rowKey]: { status: "error" } }));
      }
   };

   const handleToggleExpand = (data) => {
      const rowKey = rowKeyOf(data);
      const isOpen = expandedRowKey === rowKey;

      // Single open row: opening one closes any other. Collapse closes it.
      setExpandedRowKey(isOpen ? null : rowKey);

      if (isOpen) return; // collapsing — keep the cache, no fetch
      if (rowDetail[rowKey]) return; // already loading/loaded/empty/error — cache hit
      if (!data.en_id) {
         setRowDetail((prev) => ({ ...prev, [rowKey]: { status: "empty" } }));
         return;
      }
      fetchRowDetail(rowKey, data);
   };

   const ReconcileTableRow = ({ index, data, filteredIndex, isSelected, isExpanded, detail, onToggleExpand, onRetryDetail, onTableRowMenuClick }) => {
      const handleRowClick = (event) => {
         if (event.target.closest("td:last-child, input[type='checkbox'], .reconcile-actions-area, .dropdown-menu, .dropdown-toggle")) {
            return;
         }
         onToggleExpand(data);
      };

      return (
         <>
            <tr
               key={`tr-${index}`}
               data-id={`${data.sd_id}-${data.en_id}`}
               className={`${isExpanded ? "recon-row-open" : ""} ${isSelected ? "selected-row" : ""}`}
               onClick={handleRowClick}
               style={{ cursor: "pointer" }}>
               <td onClick={(e) => e.stopPropagation()}>
                  <Checkbox disabled={data.isError} checked={data.isChecked} onChange={() => handleCheckboxChange(data.r_index)} ariaLabel="" />
               </td>
               <td style={styles.w40} className="border-start table-invoice-statement">
                  {data.sd_page_no}
               </td>
               <td className="table-invoice-statement" style={styles.w40}>
                  {data.sd_line_no}
               </td>
               <td className={`table-invoice-statement sd_nowrap ${data.sd_ignored || !data.sd_is_invoice ? "text-muted" : ""}`} style={styles.w120}>
                  {data.sd_parsed_invoice_no || data.sd_invoice_no || ""}
               </td>
               <td className={`table-invoice-statement sd_nowrap ${data.sd_ignored || !data.sd_is_invoice ? "text-muted" : ""}`} style={styles.w120}>
                  {data.sd_invoice_date || ""}
               </td>
               <td className={`table-invoice-statement text-end sd_nowrap ${data.sd_ignored || !data.sd_is_invoice ? "text-muted" : ""}`} style={styles.w120}>
                  {data.sd_amount?.toFixed(2) || ""}
               </td>
               <td className={`border-end table-invoice-statement sd_nowrap ${data.sd_ignored || !data.sd_is_invoice ? "text-muted" : ""}`} style={styles.w120}>
                  {data.sd_po_no || ""}
               </td>
               <td className="text-center align-top bg-white" style={styles.w150}>
                  {data.sd_ignored || data.en_ignore ? null : data.match_status === "MATCHED" || data.match_status === "FULL_MATCH" ? (
                     <FaEquals size={18} color="green" />
                  ) : data.match_status === "PARTIAL" || data.match_status === "PARTIAL_MATCH" ? (
                     <FaNotEqual size={18} color="orange" />
                  ) : data.match_status === "UNMATCHED" ? (
                     <FaTimes size={18} color="red" />
                  ) : data.match_status === "NO_ERP" ? (
                     <FaTimes size={18} color="gray" />
                  ) : null}
               </td>
               <td className={`border-start invoice-entries ${data.en_ignore ? "text-muted" : ""}`} style={styles.w120}>
                  {data.esh_parsed_invoice_id || data.en_invoice_id || ""}
               </td>
               <td className={`invoice-entries ${data.en_ignore ? "text-muted" : ""}`} style={styles.w120}>
                  {data.en_invoice_date || ""}
               </td>
               <td className={`invoice-entries text-end ${data.en_ignore ? "text-muted" : ""}`} style={styles.w120}>
                  {data.en_invoice_amount?.toFixed(2) || ""}
               </td>
               <td className={`border-end invoice-entries text-end ${data.en_ignore ? "text-muted" : ""}`} style={styles.w130}>
                  {data.en_loc}
               </td>
               <td style={{ ...styles.w70, ...styles.defaultCell }}>
                  <div className="d-flex justify-content-end reconcile-actions-area" onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
                     <div>
                        <Button
                           variant="link"
                           className="p-0 border-0 me-2"
                           style={{ textDecoration: "none" }}
                           onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleFollowUpModal(data);
                           }}>
                           {data.has_active_followup ? <FaFlag size={16} color="orange" /> : <FaRegFlag size={16} color="grey" />}
                        </Button>
                     </div>
                     <ReconcileDropdownMenu matchStatus={data.match_status} filteredIndex={filteredIndex} sdIgnore={data.sd_ignored} enIgnore={data.en_ignore} onMenuClick={(action) => onTableRowMenuClick(action, data, filteredIndex)} />
                  </div>
               </td>
            </tr>
            {isExpanded && <ReconcileLineDetailPanel rowData={data} detail={detail} onRetry={() => onRetryDetail(data)} />}
         </>
      );
   };

   const handleTableRowMenuContent = (action, data, filteredIndex, sortColumn, sortOrder) => {
      if (action === "edit") {
         (async () => {
            if (!imageData) {
               await fetchPdfContent();
            }
            // Ensure we get the correct index in the new filtered list
            const newIndex = filteredData.findIndex((item) => item.r_index === data.r_index);
            setFilteredReconIndex(newIndex !== -1 ? newIndex : null);
            setOriginalPageNumber(newIndex !== -1 ? filteredData[newIndex]?.sd_page_no || 1 : 1);

            setInvoiceStatementIsEdit(true);
            setIsReadOnlyFilters(true);
            setShowStatementPdfModal(false);
            setshowReconcileInvoiceStatementModal(true);
         })();
      } else if (action === "view_invoice") {
         handleStatementViewModal();
      } else if (action === "audit") {
         const newIndex = filteredData.findIndex((item) => item.r_index === data.r_index);
         setAuditFilteredRow(data);
         setShowAudit(true);
      } else if (action === "ignore_invoice" || action === "ignore_supplier" || action === "undo_ignore_supplier" || action === "undo_ignore_invoice") {
         handleIgnoreAction(action, data, filteredIndex, sortColumn, sortOrder);
      }
   };

   const handleIgnoreSupplierBatchAction = async (selectedItems, _type, _action) => {
      if (selectedItems.length === 0) {
         triggerToast("warning", "No items selected.", false, "", false, 0);
         return;
      }

      const url = "/update_ignore.sz";
      const method = "POST";

      try {
         const results = await Promise.all(
            selectedItems.map((_id) => {
               const formData = new FormData();
               formData.append("_action", _action);
               formData.append("_type", _type);
               formData.append("_id", _id);
               return fetchData(url, method, formData, "form-data");
            })
         );

         const succeededIds = results
            .map(({ responseData }, i) => ({ responseData, originalId: selectedItems[i] }))
            .filter(({ responseData }) => responseData?.st === 1)
            .map(({ responseData, originalId }) => responseData?.payload?.id ?? originalId);

         if (succeededIds.length > 0) {
            setPayloadRecon((prevRecon) =>
               prevRecon.map((item) =>
                  succeededIds.includes(item.sd_id) ? { ...item, sd_ignored: _action === "set" } : item
               )
            );
         }

         const failedCount = selectedItems.length - succeededIds.length;
         if (failedCount > 0) {
            triggerToast("warning", `${failedCount} item(s) could not be updated.`, true, "Partial Error", false, 0);
         }
      } catch (error) {
         triggerToast("error", "We are experiencing connectivity issues, please try again later.", true, "Network Issue", false, 0);
      } finally {
         document.getElementById("dropdownBatchActions")?.blur();
      }
   };

   const handleIgnoreAction = async (action, data, filteredIndex, currentSortColumn, currentSortOrder) => {
      let _action;
      let _type;
      let _id;

      if (action === "ignore_supplier" || action === "undo_ignore_supplier") {
         _type = "sd";
         _action = data.sd_ignored ? "undo" : "set";
         _id = data.sd_id;
      } else {
         _type = "in";
         _action = data.en_ignore ? "undo" : "set";
         _id = data.en_id;
      }
      const url = "/update_ignore.sz";
      const method = "POST";
      const formData = new FormData();
      formData.append("_action", _action);
      formData.append("_type", _type);
      formData.append("_id", _id);

      try {
         const { responseData, fetchLoading, fetchError } = await fetchData(url, method, formData, "form-data");

         if (responseData.st === 1) {
            const updatedId = responseData?.payload?.id ?? _id;
            const newSdIgnored = _type === "sd" ? _action === "set" : undefined;
            const newEnIgnore = _type === "in" ? _action === "set" : undefined;

            setPayloadRecon((prevRecon) =>
               prevRecon.map((item) =>
                  item.sd_id === updatedId || item.en_id === updatedId
                     ? {
                          ...item,
                          ...(newSdIgnored !== undefined && { sd_ignored: newSdIgnored }),
                          ...(newEnIgnore !== undefined && { en_ignore: newEnIgnore }),
                       }
                     : item
               )
            );
         } else {
            triggerToast("error", responseData.mg || " Failed to update ignore status.", true, "Error", false, 0);
         }
      } catch (error) {
         triggerToast("error", "We are experiencing connectivity issues, please try again later.", true, "Network Issue", false, 0);
      }
   };

   const handleCheckboxChange = (rowId) => {
      setPayloadRecon((prevRows) => {
         const updatedRows = prevRows.map((row) => (row.r_index === rowId ? { ...row, isChecked: !row.isChecked } : row));

         // After toggling, calculate checkbox state **based on filteredData**, not entire payload
         const visibleRows = updatedRows.filter((row) => {
            // replicate your filteredData logic here if needed, or rely on useMemo(filteredData)
            // safest: use filteredData directly (since it recomputes after this update)
            return true; // or use filteredData instead
         });

         const allChecked = visibleRows.every((row) => row.isChecked);
         const someChecked = visibleRows.some((row) => row.isChecked);
         setIsHeaderCheckboxChecked(allChecked ? true : someChecked ? "indeterminate" : false);

         return updatedRows;
      });
   };

   const isHeaderCheckboxIndeterminate = () => {
      const visibleValidRecons = filteredData.filter((recon) => !recon.isError);

      const allChecked = visibleValidRecons.length > 0 && visibleValidRecons.every((recon) => recon.isChecked);
      const noneChecked = visibleValidRecons.length > 0 && visibleValidRecons.every((recon) => !recon.isChecked);

      return !allChecked && !noneChecked;
   };

   const handleSelectAllCheckboxChange = () => {
      const shouldCheckAll = !isHeaderCheckboxChecked;

      setPayloadRecon((prevRecon) =>
         prevRecon.map((recon) => {
            // If this recon is part of the currently visible (filtered) data and is not an error, toggle it
            const isVisible = filteredData.some((item) => item.r_index === recon.r_index);
            if (isVisible && !recon.isError) {
               return { ...recon, isChecked: shouldCheckAll };
            }
            return recon; // Leave all other rows unchanged
         })
      );

      setIsHeaderCheckboxChecked(shouldCheckAll);
   };

   const handleFilterChange = (e) => {
      if (e.value === "IGNORE") {
         setHideIgnored((prev) => !prev);
      } else {
         setSelectedFilter(e.value);
      }
      //setSelectedFilter(e.target.value);
   };

   const filteredData = useMemo(() => {
      if (!payloadRecon) return [];

      let data = payloadRecon.filter((row) => {
         // Match status filtering with new filter values
         let matchStatusMatch = true;
         if (selectedFilter === "MATCHED") {
            matchStatusMatch = row.match_status === "MATCHED" || row.match_status === "FULL_MATCH";
         } else if (selectedFilter === "PARTIAL") {
            matchStatusMatch = row.match_status === "PARTIAL_MATCH";
         } else if (selectedFilter === "UNMATCHED") {
            matchStatusMatch = row.match_status === "UNMATCHED" || row.match_status === "NO_ERP";
         } else if (selectedFilter === "NO_ERP") {
            matchStatusMatch = row.match_status === "NO_ERP";
         } else if (selectedFilter === "KEYING_ISSUE") {
            // Show items with keying issues - check if there's a flag or specific status
            matchStatusMatch = row.has_keying_issue === true || row.keying_issue === true;
         } else if (selectedFilter === "OVER_ALLOCATED") {
            // Show items that are over-allocated - check if there's a flag or specific status
            matchStatusMatch = row.is_over_allocated === true || row.over_allocated === true;
         }
         // else selectedFilter === "ALL" - show everything (matchStatusMatch stays true)

         const ignoreMatch = !hideIgnored || (!row.sd_ignored && !row.en_ignore && row.sd_is_invoice);
         const supplierInvoiceMatch = !supplierInvoiceNumberFilter.trim() || row.sd_invoice_no?.toLowerCase().includes(supplierInvoiceNumberFilter.toLowerCase());

         const supplierPoMatch = !supplierInvoicePoNoFilter.trim() || row.sd_po_no?.toLowerCase().includes(supplierInvoicePoNoFilter.toLowerCase());
         const supplierAmountMatch = !supplierInvoiceAmountFilter.trim() || (row.sd_amount?.toFixed(2) || "").startsWith(supplierInvoiceAmountFilter.trim());

         const supplierDateMatch =
            !supplierInvoiceDateFilter ||
            (() => {
               const normalizedFilter = supplierInvoiceDateFilter instanceof Date ? supplierInvoiceDateFilter.toISOString().split("T")[0].replace(/[-]/g, "") : String(supplierInvoiceDateFilter).replace(/[_-]/g, "");
               const normalizedDate = (row.sd_invoice_date || "").replace(/[-]/g, "");
               return normalizedDate.startsWith(normalizedFilter);
            })();
         const entryInvoiceMatch = !entryInvoiceNumberFilter.trim() || row.en_invoice_id?.toLowerCase().includes(entryInvoiceNumberFilter.toLowerCase());
         const entryAmountMatch = !entryInvoiceAmountFilter.trim() || (row.en_invoice_amount?.toFixed(2) || "").startsWith(entryInvoiceAmountFilter.trim());
         const entryDateMatch =
            !entryInvoiceDateFilter ||
            (() => {
               const normalizedFilter = entryInvoiceDateFilter instanceof Date ? entryInvoiceDateFilter.toISOString().split("T")[0].replace(/[-]/g, "") : String(entryInvoiceDateFilter).replace(/[_-]/g, "");
               const normalizedDate = (row.en_invoice_date || "").replace(/[-]/g, "");
               return normalizedDate.startsWith(normalizedFilter);
            })();
         return matchStatusMatch && ignoreMatch && supplierInvoiceMatch && supplierPoMatch && supplierAmountMatch && supplierDateMatch && entryInvoiceMatch && entryAmountMatch && entryDateMatch;
      });

      if (sortColumn) {
         data.sort((a, b) => {
            let valA = a[sortColumn] ?? "";
            let valB = b[sortColumn] ?? "";

            if (typeof valA === "number" && typeof valB === "number") {
               return sortOrder === "asc" ? valA - valB : valB - valA;
            }

            valA = String(valA);
            valB = String(valB);
            return sortOrder === "asc" ? valA.localeCompare(valB, undefined, { numeric: true }) : valB.localeCompare(valA, undefined, { numeric: true });
         });
      }

      return data;
   }, [selectedFilter, hideIgnored, supplierInvoiceNumberFilter, supplierInvoicePoNoFilter, supplierInvoiceAmountFilter, supplierInvoiceDateFilter, entryInvoiceNumberFilter, entryInvoiceAmountFilter, entryInvoiceDateFilter, payloadRecon, sortColumn, sortOrder]);

   const handleSort = (column) => {
      setSortOrder((prevOrder) => (sortColumn === column && prevOrder === "asc" ? "desc" : "asc"));
      setSortColumn(column);
   };

   const getSortIndicator = (column) => {
      if (sortColumn === column) {
         return <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "3px" }}>{sortOrder === "asc" ? <FaLongArrowAltDown size={14} /> : <FaLongArrowAltUp size={14} />}</span>;
      }
      return null;
   };

   const handleClearFilters = () => {
      setSupplierInvoiceNumberFilter("");
      setSupplierInvoicePoNoFilter("");
      setSupplierInvoiceAmountFilter("");
      setSupplierInvoiceDateFilter("");
      setEntryInvoiceNumberFilter("");
      setEntryInvoiceAmountFilter("");
      setEntryInvoiceDateFilter("");
      setShowSupplierDateCalendar(false);
      setShowEntryDateCalendar(false);
      
      // Blur the button to remove focus styling
      document.getElementById("clearReconcileView")?.blur();
   };

   const handleFollowUpModalClose = () => {
      setFollowUpSupplierDetailID(null);
      setFollowUpExternalSourceHeaderID(null);
      setFollowUpSupplierInvoiceNumber("");
      setFollowUpExternalInvoiceNumber("");
      setShowFollowup(false);
   };

   const handleFollowUpModal = (data) => {
      setFollowUpSupplierDetailID(data.sd_id);
      setFollowUpExternalSourceHeaderID(data.en_id);
      setFollowUpSupplierInvoiceNumber(data.sd_parsed_invoice_no || data.sd_invoice_no || "");
      setFollowUpExternalInvoiceNumber(data.esh_parsed_invoice_id || data.en_invoice_id || "");
      setShowFollowup(true);
      console.log("FOLLOWUP", showFollowup, followUpSupplierDetailID, followUpExternalSourceHeaderID);
   };

   const handleAuditModalClose = () => {
      setAuditFilteredRow(null);
      setShowAudit(false);
   };

   const handleFollowUpStatusChange = (status, index) => {
      console.log(`HANDLE FOLLOWUP STATUS CHANGE ${index}:`, status);
      setPayloadRecon((prevRecon) =>
         prevRecon.map((item) =>
            (item.sd_id !== null && item.sd_id === followUpSupplierDetailID) || (item.en_id !== null && item.en_id === followUpExternalSourceHeaderID)
               ? {
                    ...item,
                    has_active_followup: status,
                 }
               : item
         )
      );
   };

   // Running totals
   const { totalSupplierAmount, totalEntryAmount, matchedInvoiceCount, totalInvoiceCount, totalOverrideCount, totalEntriesCount } = useMemo(() => {
      return payloadRecon.reduce(
         (acc, item) => {
            if (!item.sd_ignored && item.sd_is_invoice) {
               acc.totalSupplierAmount += item.sd_amount || 0;
               acc.totalInvoiceCount += 1;

               if (item.match_status === "MATCHED" || item.match_status === "FULL_MATCH") {
                  acc.matchedInvoiceCount += 1;
               }
               if (item.sd_ovr) {
                  acc.totalOverrideCount += 1;
               }
            }

            if (item.en_invoice_id) {
               acc.totalEntriesCount += 1;
            }

            if (!item.en_ignore) {
               acc.totalEntryAmount += item.en_invoice_amount || 0;
            }

            return acc;
         },
         { totalSupplierAmount: 0, totalEntryAmount: 0, matchedInvoiceCount: 0, totalInvoiceCount: 0, totalOverrideCount: 0, totalEntriesCount: 0 }
      );
   }, [payloadRecon]);

   // Convert totals to fixed decimals
   const formattedTotalSupplierAmount = totalSupplierAmount.toFixed(2);
   const formattedTotalEntryAmount = totalEntryAmount.toFixed(2);

   // Compute completion percentage
   const completionPercentage = useMemo(() => {
      if (totalInvoiceCount === 0) return 0;
      return Math.round((matchedInvoiceCount / totalInvoiceCount) * 100);
   }, [matchedInvoiceCount, totalInvoiceCount]);

   const overviewMatchedCount = Number.isFinite(summaryMatchedCount) ? summaryMatchedCount : matchedInvoiceCount;
   const overviewInvoiceLineCount = Number.isFinite(summaryInvoiceLineCount) ? summaryInvoiceLineCount : totalInvoiceCount;
   const overviewCompletionPercentage = overviewInvoiceLineCount > 0 ? Math.round((overviewMatchedCount / overviewInvoiceLineCount) * 100) : 0;

   console.log("Parent re-rendered at", new Date().toISOString());

   const handleUpdateReconData = (updatedFilteredRecon) => {
      setPayloadRecon((prevRecon) => {
         const updatedMap = new Map(updatedFilteredRecon.map((item) => [item.sd_id, item]));
         return prevRecon.map((item) =>
            updatedMap.has(item.sd_id) ? { ...item, ...updatedMap.get(item.sd_id) } : item
         );
      });
   };

   const exportToCSV = () => {
      if (!filteredData || filteredData.length === 0) {
         return;
      }

      const escapeCSV = (value) => {
         if (value === null || value === undefined) return "";
         const str = String(value);
         // Escape double quotes and wrap in quotes
         return `"${str.replace(/"/g, '""')}"`;
      };

      const headers = ["Page", "Line", "Supplier Invoice", "Invoice Date", "Supplier PO", "Supplier Amount", "Match Status", "Entry Invoice", "Entry Invoice Date", "Entry Amount", "Entry Location", "Ignored (Supplier)", "Ignored (Entry)"];
      const rows = filteredData.map((item) => [escapeCSV(item.sd_page_no), escapeCSV(item.sd_line_no), escapeCSV(item.sd_invoice_no), escapeCSV(item.sd_invoice_date), escapeCSV(item.sd_po_no), escapeCSV(item.sd_amount), escapeCSV(item.match_status), escapeCSV(item.en_invoice_id), escapeCSV(item.en_invoice_date), escapeCSV(item.en_invoice_amount), escapeCSV(item.en_loc), escapeCSV(item.sd_ignored ? "Yes" : "No"), escapeCSV(item.en_ignore ? "Yes" : "No")].join(","));
      const csvContent = [headers.map(escapeCSV).join(","), ...rows].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

      const fileName = `Reconcile_${selectedInvoiceStatementName?.replace(/\s+/g, "-")}_${selectedInvoiceStatementDate?.replace(/[:/\\\s]/g, "-")}.csv`;
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
   };

   useEffect(() => {
      const handleScroll = () => {
         const scrollY = window.scrollY;
         if (scrollY > 50 && !isShrunk) {
            setIsShrunk(true);
         } else if (scrollY <= 50 && isShrunk) {
            setIsShrunk(false);
         }
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
   }, [isShrunk]);

   return (
      <>
         <Header />
         <div className="main main-app p-3 p-lg-4 p-xxl-5">
            <Row className="g-3 g-lg-4 mb-4" style={{ position: "relative" }}>
               <Col className="d-flex justify-content-start">
                  <h2 className="main-title fs-4 mb-1 d-flex align-items-center">
                     <div
                        role="button"
                        tabIndex={0}
                        onClick={handleBackClick}
                        onKeyDown={(e) => {
                           if (e.key === "Enter" || e.key === " ") handleBackClick();
                        }}
                        className="d-inline-flex align-items-center text-primary"
                        style={{ cursor: "pointer" }}>
                        <FaArrowLeft size={40} title="Back to Invoice Statements" className="pe-3" />
                     </div>
                     <div className="d-flex align-items-baseline ms-3">
                        <span>{selectedInvoiceStatementName}</span> <span className="fs-13 fw-light ps-2 pe-2 align-baseline">ending</span> {selectedInvoiceStatementDate}
                     </div>
                  </h2>
               </Col>
               <div
                  onClick={handleToggleReconcileSummary}
                  className="text-primary reconcile-summary d-inline-flex flex-column align-items-center"
                  data-bs-toggle="collapse"
                  data-bs-target="#reconciliationOverview"
                  aria-expanded="false"
                  aria-controls="reconciliationOverview"
                  style={{ position: "absolute", top: 0, left: "50%", transform: "translateX(-50%)", cursor: "pointer", width: "fit-content" }}>
                  <h5 className="mb-0">Reconciliation Overview</h5>
                  <span>{isExpandedReconcileSummary ? <FaChevronUp size={20} /> : <FaChevronDown size={20} />}</span>
               </div>
            </Row>
            <Sticky enabled={isExpandedReconcileSummary} top={100} innerZ={799} className="" onStateChange={handleStickyStateChange}>
               <div style={{ backgroundColor: "#fbfcfe", marginTop: "-28px" }} className="collapse" id="reconciliationOverview">
                  <Row className="g-3 d-flex justify-content-center flex-wrap" style={isShrunk ? { height: "100px", direction: "ltr" } : { direction: "ltr" }}>
                     <Col md={12} xl={4} xxl={4} className="d-flex" style={{ order: 1 }}>
                        <div className={`card w-100  d-flex flex-column ${isShrunk ? "shrink-card h-75" : "h-100"}`}>
                           <div className={`card-body ${isShrunk ? "shrink-card" : ""} ${classes.cardBody}`}>
                              <div className="d-flex justify-content-around text-center">
                                 <div className="d-flex flex-column align-items-center">
                                    <div>Invoice Statement</div>
                                    <div>Sub-Total</div>
                                 </div>
                                 <div className="d-flex flex-column align-items-center"></div>
                                 <div className="d-flex flex-column align-items-center">
                                    <div>Protractor Entries</div>
                                    <div>Sub-Total</div>
                                 </div>
                                 <div className="d-flex flex-column align-items-center">
                                    <div></div>
                                 </div>
                                 <div className="d-flex flex-column align-items-center">
                                    <div>Difference</div>
                                 </div>
                              </div>

                              {/* Values Row */}
                              <div className={`d-flex justify-content-around text-center ${isShrunk ? "mt-1" : "mt-2"}`}>
                                 <div className="d-flex flex-column align-items-center">
                                    <span>{formattedTotalSupplierAmount}</span>
                                 </div>
                                 <div className="d-flex flex-column align-items-center">
                                    <span>
                                       <FaMinus color="black" />
                                    </span>
                                 </div>
                                 <div className="d-flex flex-column align-items-center">
                                    <span>{formattedTotalEntryAmount}</span>
                                 </div>
                                 <div className="d-flex flex-column align-items-center">
                                    <span>{formattedTotalSupplierAmount - formattedTotalEntryAmount == 0 ? <FaEquals color="green" /> : <FaNotEqual color="orange" />}</span>
                                 </div>
                                 <div className="d-flex flex-column align-items-center">
                                    <span className="fs-4">{(formattedTotalSupplierAmount - formattedTotalEntryAmount).toFixed(2)}</span>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </Col>
                     <Col md={12} xl={4} xxl={4} className="d-flex" style={{ order: 2 }}>
                        <div className={`card w-100  d-flex flex-column ${isShrunk ? "shrink-card h-75" : "h-100"}`}>
                           <div className={`card-body d-flex flex-column justify-content-between ${isShrunk ? "shrink-card" : ""} ${classes.cardBody}`}>
                              <Row className="d-flex align-items-start">
                                 <Col className="d-flex flex-column align-items-center justify-content-center">
                                    <p className="mb-0 text-nowrap">Document Grade</p>
                                    <p>
                                       <span>{documentGrade}</span>
                                    </p>
                                 </Col>
                                 <Col className="d-flex flex-column align-items-center justify-content-center">
                                    <p className="mb-0">Invoices Reconciled</p>
                                    <p className={`${isShrunk ? "mb-2" : ""}`}>
                                       <span>{overviewMatchedCount}</span> / {overviewInvoiceLineCount}
                                    </p>
                                    <ProgressBar completion={overviewCompletionPercentage} />
                                 </Col>
                                 <Col className="d-flex flex-column align-items-center justify-content-center">
                                    <p className="mb-0">Overrides</p>
                                    <p>
                                       <span>{totalOverrideCount}</span>
                                    </p>
                                 </Col>
                              </Row>
                           </div>
                        </div>
                     </Col>

                     <Col md={12} xl={4} xxl={4} className="d-flex justify-content-center pe-1" style={{ order: 3 }}>
                        <div className={`card w-100 ${isShrunk ? "shrink-card h-75" : "h-100"}`}>
                           <div className="card-header mb-0 pb-0">{!isShrunk && <h5 className="mb-0 pb-0 fs-13">Protractor Entries for Invoice Statement</h5>}</div>
                           <div className={`card-body ${isShrunk ? "shrink-card" : ""} ${classes.cardBody}`}>
                              <div className="d-flex justify-content-between">
                                 <div className="d-flex justify-content-between align-items-center w-100">
                                    <div>Total invoices posted for Supplier</div>
                                    <div className="fw-normal">{totalEntriesCount}</div>
                                 </div>
                              </div>
                              <div className="d-flex justify-content-between">
                                 <div className="d-flex justify-content-between align-items-center w-100">
                                    <div>Total invoices documents uploaded for Supplier</div>
                                    <div className="fw-normal">0</div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </Col>
                  </Row>
                  <Row>
                     <Col>
                        <div onClick={handleToggleReconcileSummary} className="text-center cursor-pointer text-primary reconcile-summary pt-2 pb-2" data-bs-toggle="collapse" data-bs-target="#reconciliationOverview" aria-expanded="false" aria-controls="reconciliationOverview" style={{ cursor: "pointer" }}>
                           <span>{isExpandedReconcileSummary ? <FaChevronUp size={20} /> : <FaChevronDown size={20} />}</span>
                        </div>
                        <hr className="m-0" />
                     </Col>
                  </Row>
               </div>
            </Sticky>
            <div style={{ paddingTop: isExpandedReconcileSummary ? "25px" : 0 }}>
               <Row className="pt-4 g-3 g-lg-4">
                  <Col>
                     <div className="d-flex justify-content-between">
                        <div className="d-flex flex-nowrap">
                           <div className="dropdown pe-2">
                              <span style={{ width: "48px", paddingLeft: "10px" }} className="align-bottom">
                                 <ArrowTurnLeftDown style={{ width: "25px", height: "25px" }} />
                              </span>
                              <button className="btn btn-outline-secondary rounded-pill dropdown-toggle ms-2 pt-1 pb-1" type="button" id="dropdownBatchActions" data-bs-toggle="dropdown" disabled={isReadOnlyFilters} aria-expanded="false">
                                 Batch Actions
                                 {filteredData.filter((item) => item.isChecked).length > 0 && (
                                    <span className="badge bg-primary ms-1">{filteredData.filter((item) => item.isChecked).length}</span>
                                 )}
                              </button>
                              <ul className="dropdown-menu" aria-labelledby="dropdownBatchActions">
                                 <li>
                                    <button
                                       className="dropdown-item"
                                       onClick={() => {
                                          const selectedItems = filteredData
                                             .filter((item) => item.isChecked && !item.sd_ignored)
                                             .map((item) => item.sd_id);

                                          if (selectedItems.length > 0) {
                                             handleIgnoreSupplierBatchAction(selectedItems, "sd", "set");
                                          } else {
                                             triggerToast("warning", "No non-ignored items selected.", false, "", false);
                                          }
                                       }}>
                                       Ignore Supplier
                                    </button>
                                 </li>
                                 <li>
                                    <button
                                       className="dropdown-item"
                                       onClick={() => {
                                          const selectedItems = filteredData
                                             .filter((item) => item.isChecked && item.sd_ignored)
                                             .map((item) => item.sd_id);

                                          if (selectedItems.length > 0) {
                                             handleIgnoreSupplierBatchAction(selectedItems, "sd", "undo");
                                          } else {
                                             triggerToast("warning", "No ignored items selected.", false, "", false);
                                          }
                                       }}>
                                       Undo Ignore Supplier
                                    </button>
                                 </li>
                              </ul>
                           </div>
                           <div className="">
                              <button className="btn btn-outline-secondary rounded-pill ms-3 pt-1 pb-1" id="clearReconcileView" type="button" disabled={isReadOnlyFilters} onClick={handleClearFilters}>
                                 Clear Filters
                              </button>
                           </div>
                           <button onClick={handleStatementViewModal} className="btn btn-outline-secondary rounded-pill ms-3 pt-1 pb-1" id="InvoiceStatementView" disabled={isReadOnlyFilters || pdfLoading} aria-busy={pdfLoading} type="button">
                              {pdfLoading ? "Loading PDF…" : "View Invoice Statement"}
                           </button>
                        </div>
                     </div>
                  </Col>
               </Row>
               <Row className="g-3 g-lg-4">
                  <Col>
                     <div className="table-container ms-0 d-flex justify-content-start mb-2 ps-0" style={{ maxWidth: "1335px" }}>
                        <div className="table-responsive ms-0 me-0" style={{ maxWidth: "1335px", minWidth: "1100px", overflowx: "auto", margin: "auto", minHeight: filteredData.length < 5 ? "500px" : undefined }}>
                           <table className="table table-hover reconcile" style={{ width: "100%" }}>
                              <thead>
                                 <tr key="h1" style={{ borderBottom: "0px", borderStyle: "none" }} className="pe-0">
                                    <th style={{ borderBottom: "0px", borderStyle: "none" }}></th>
                                    <th colSpan="6" scope="colgroup" className="pe-0 ps-0 pb-0" style={{ borderBottom: "0px", borderStyle: "none" }}>
                                       <div className="card-bc border-0">
                                          <div className="card-body-center border-top border-1 pb-0 pt-0" style={{ "--card-body-content": "'Supplier Statement'" }}></div>
                                       </div>
                                    </th>
                                    <th style={{ borderBottom: "0px", borderStyle: "none" }}>&nbsp;</th>
                                    <th colSpan="4" className="ps-0 pb-0 pe-0" style={{ borderBottom: "0px", borderStyle: "none" }}>
                                       <div className="card-bc border-0">
                                          <div className="card-body-center border-top border-1 pb-0 pt-0" style={{ "--card-body-content": "'Protractor Entries'" }}></div>
                                       </div>
                                    </th>
                                 </tr>
                                 <tr key="h2" style={{ height: "100px" }}>
                                    <th className="" scope="col" style={{ width: "40px" }}>
                                       <HeaderCheckbox indeterminate={isHeaderCheckboxIndeterminate()} checked={isHeaderCheckboxChecked} onChange={handleSelectAllCheckboxChange} disabled={isReadOnlyFilters} ariaLabel="Select Line" />
                                    </th>
                                    <th style={{ ...styles.w40, paddingBottom: "52px", cursor: "pointer" }} onClick={!isReadOnlyFilters ? () => handleSort("sd_page_no") : undefined} className="border-start">
                                       <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "5px" }}>Page {getSortIndicator("sd_page_no")}</span>
                                    </th>
                                    <th style={{ ...styles.w40, paddingBottom: "52px", cursor: "pointer" }} onClick={!isReadOnlyFilters ? () => handleSort("sd_line_no") : undefined}>
                                       <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "5px" }}>Line {getSortIndicator("sd_line_no")}</span>
                                    </th>
                                    <th style={{ ...styles.w120, cursor: "pointer" }} onClick={!isReadOnlyFilters ? () => handleSort("sd_invoice_no") : undefined}>
                                       <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "5px" }}>Invoice Number {getSortIndicator("sd_invoice_no")}</span>
                                       <TextFilterInput placeholder="Invoice No" value={supplierInvoiceNumberFilter} onFilterChange={(value) => setSupplierInvoiceNumberFilter(value)} readOnly={isReadOnlyFilters} />
                                    </th>
                                    <th style={{ ...styles.w120, cursor: "pointer" }} onClick={!isReadOnlyFilters ? () => handleSort("sd_invoice_date") : undefined}>
                                       <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "5px" }}>Invoice Date {getSortIndicator("sd_invoice_date")}</span>
                                       <div ref={supplierDatePickerRef} style={{ position: "relative" }} onClick={(e) => e.stopPropagation()}>
                                          <input
                                             type="text"
                                             value={formatDateInputValue(supplierInvoiceDateFilter)}
                                             onChange={(e) => {
                                                const value = e.target.value;
                                                if (!value) {
                                                   setSupplierInvoiceDateFilter("");
                                                   return;
                                                }
                                                const parsed = parseDate(value);
                                                if (parsed) {
                                                   setSupplierInvoiceDateFilter(parsed);
                                                } else {
                                                   setSupplierInvoiceDateFilter(value);
                                                }
                                             }}
                                             onFocus={() => !isReadOnlyFilters && setShowSupplierDateCalendar(true)}
                                             readOnly={isReadOnlyFilters}
                                             placeholder="YYYY-MM-DD"
                                             className="mt-2 form-control"
                                          />
                                          {showSupplierDateCalendar && !isReadOnlyFilters && (
                                             <div className="position-absolute bg-white border rounded shadow p-2 mt-1 z-3">
                                                <DayPicker
                                                   mode="single"
                                                   selected={supplierInvoiceDateFilter instanceof Date ? supplierInvoiceDateFilter : parseDate(String(supplierInvoiceDateFilter || "")) || undefined}
                                                   onSelect={(date) => {
                                                      setSupplierInvoiceDateFilter(date || "");
                                                      setShowSupplierDateCalendar(false);
                                                   }}
                                                />
                                             </div>
                                          )}
                                       </div>
                                    </th>
                                    <th style={{ ...styles.w120, cursor: "pointer" }} onClick={!isReadOnlyFilters ? () => handleSort("sd_amount") : undefined}>
                                       <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "5px" }}>Amount {getSortIndicator("sd_amount")}</span>
                                       <div className="mt-2" style={{ position: "relative" }} onClick={(e) => e.stopPropagation()}>
                                          <CurrencyInput
                                             value={supplierInvoiceAmountFilter}
                                             onAmountChange={setSupplierInvoiceAmountFilter}
                                             //onAmountChange={(value) => {
                                             //   console.log("Amount changed:", value);
                                             //   setSupplierInvoiceAmountFilter(value);
                                             //}}
                                             readOnly={isReadOnlyFilters} 
                                          />
                                       </div>
                                    </th>
                                    <th style={{ ...styles.w120, cursor: "pointer" }} className="border-end" onClick={!isReadOnlyFilters ? () => handleSort("sd_po_no") : undefined}>
                                       <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "5px" }}>Po No {getSortIndicator("sd_po_no")}</span>
                                       <TextFilterInput placeholder="Po No" value={supplierInvoicePoNoFilter} onFilterChange={(value) => setSupplierInvoicePoNoFilter(value)} readOnly={isReadOnlyFilters} />
                                    </th>
                                    <th style={styles.w150} className="text-center align-bottom">
                                       <span>Match</span>
                                       <Select
                                          options={matched_options}
                                          value={selectedFilter !== "ALL"
                                             ? { ...matched_options.find((option) => option.value === selectedFilter), label: `${filteredData.length} ${matched_options.find((option) => option.value === selectedFilter)?.label}` }
                                             : matched_options.find((option) => option.value === selectedFilter)
                                          }
                                          onChange={handleFilterChange}
                                          isDisabled={isReadOnlyFilters}
                                          className="w-100 mt-2"
                                          styles={{
                                             option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isSelected ? "var(--bs-primary)" : state.isFocused ? "var(--bs-dropdown-link-hover-bg)" : "white",
                                                color: state.isSelected ? "white" : "var(--bs-dropdown-link-hover-color)",
                                                fontWeight: state.isSelected ? "bold" : "normal",
                                                textDecoration: "none",
                                                transition: "background-color 0.2s ease-in-out",
                                                "&:hover, &:focus": {
                                                   backgroundColor: "#e2e5ec",

                                                   textDecoration: "none",
                                                },
                                             }),
                                             control: (provided, state) => ({
                                                ...provided,
                                                borderRadius: "0.25rem",
                                                fontSize: "0.875rem",
                                                fontWeight: "normal",
                                                textAlign: "left",
                                                height: "calc(2.25rem - 2px)",
                                                minHeight: "unset",
                                                borderColor: state.isFocused ? "rgb(167.5, 183, 236)" : "#e2e5ec",
                                                backgroundColor: "#fff",
                                                color: "var(--bs-body-color)",
                                                boxShadow: state.isFocused ? "0 1px 1px rgba(226, 229, 236, 0.25), 0 2px 2px rgba(226, 229, 236, 0.2), 0 4px 4px rgba(226, 229, 236, 0.15), 0 8px 8px rgba(226, 229, 236, 0.1)" : "none",
                                                "&:hover": {
                                                   borderColor: "#ccd2da",
                                                },
                                             }),
                                             singleValue: (provided) => ({
                                                ...provided,
                                                fontWeight: "normal",
                                                textAlign: "left",
                                             }),
                                             menu: (provided) => ({
                                                ...provided,
                                                minWidth: "180px",
                                                maxWidth: "180px",
                                                overflow: "hidden",
                                                borderColor: "rgba(65, 80, 95, 0.16)",
                                                zIndex: 9999,
                                             }),
                                             menuList: (provided) => ({
                                                ...provided,
                                                maxHeight: "none",
                                                overflowY: "auto",
                                                overflowX: "hidden",
                                             }),
                                             option: (provided, state) => ({
                                                ...provided,
                                                textAlign: "left",
                                                fontWeight: state.isSelected ? "normal" : "normal",
                                             }),
                                          }}
                                       />
                                    </th>
                                    <th style={{ ...styles.w120, cursor: "pointer" }} onClick={!isReadOnlyFilters ? () => handleSort("en_invoice_id") : undefined} className="border-start">
                                       <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "5px" }}>Invoice Number {getSortIndicator("en_invoice_id")}</span>
                                       <TextFilterInput placeholder="Invoice No" value={entryInvoiceNumberFilter} onFilterChange={(value) => setEntryInvoiceNumberFilter(value)} readOnly={isReadOnlyFilters} />
                                    </th>
                                    <th style={{ ...styles.w120, cursor: "pointer" }} onClick={!isReadOnlyFilters ? () => handleSort("en_invoice_date") : undefined}>
                                       <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "5px" }}>Invoice Date {getSortIndicator("en_invoice_date")}</span>
                                       <div ref={entryDatePickerRef} style={{ position: "relative" }} onClick={(e) => e.stopPropagation()}>
                                          <input
                                             type="text"
                                             value={formatDateInputValue(entryInvoiceDateFilter)}
                                             onChange={(e) => {
                                                const value = e.target.value;
                                                if (!value) {
                                                   setEntryInvoiceDateFilter("");
                                                   return;
                                                }
                                                const parsed = parseDate(value);
                                                if (parsed) {
                                                   setEntryInvoiceDateFilter(parsed);
                                                } else {
                                                   setEntryInvoiceDateFilter(value);
                                                }
                                             }}
                                             onFocus={() => !isReadOnlyFilters && setShowEntryDateCalendar(true)}
                                             readOnly={isReadOnlyFilters}
                                             placeholder="YYYY-MM-DD"
                                             className="mt-2 form-control"
                                          />
                                          {showEntryDateCalendar && !isReadOnlyFilters && (
                                             <div className="position-absolute bg-white border rounded shadow p-2 mt-1 z-3">
                                                <DayPicker
                                                   mode="single"
                                                   selected={entryInvoiceDateFilter instanceof Date ? entryInvoiceDateFilter : parseDate(String(entryInvoiceDateFilter || "")) || undefined}
                                                   onSelect={(date) => {
                                                      setEntryInvoiceDateFilter(date || "");
                                                      setShowEntryDateCalendar(false);
                                                   }}
                                                />
                                             </div>
                                          )}
                                       </div>
                                    </th>
                                    <th style={{ ...styles.w120, cursor: "pointer" }} onClick={!isReadOnlyFilters ? () => handleSort("en_invoice_amount") : undefined} className="">
                                       <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "5px" }}>Amount {getSortIndicator("en_invoice_amount")}</span>
                                       <div className="mt-2" style={{ position: "relative" }} onClick={(e) => e.stopPropagation()}>
                                          <CurrencyInput value={entryInvoiceAmountFilter} onAmountChange={setEntryInvoiceAmountFilter} readOnly={isReadOnlyFilters} />
                                       </div>
                                    </th>
                                    <th style={{ ...styles.w130, paddingBottom: "52px", cursor: "pointer" }} onClick={!isReadOnlyFilters ? () => handleSort("en_loc") : undefined} className="border-end">
                                       <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "5px" }}>Location {getSortIndicator("en_loc")}</span>
                                    </th>
                                    <th style={styles.headerActions} className="d-flex justify-content-between align-items-start border-0">
                                       <div style={{ marginTop: "20px" }}>
                                          <span>Actions</span>
                                       </div>
                                       <div className="" style={{ marginTop: "20px" }}>
                                          <TableSettingDropdown showTableDropdown={showTableDropdown} handleTableToggleDropdown={handleTableToggleDropdown} handleExport={handleExport} handleTableDropdownCancelChanges={handleTableDropdownCancelChanges} filteredData={filteredData} />
                                       </div>
                                    </th>
                                 </tr>
                              </thead>
                              <tbody>
                                 {showSpinner ? (
                                    <tr key="loading-row">
                                       <td colSpan="12" className="text-center py-5">
                                          <LoadingIndicator state={loadingState} />
                                       </td>
                                    </tr>
                                 ) : filteredData.length > 0 ? (
                                    filteredData.map((data, index) => (
                                       <ReconcileTableRow
                                          key={data.r_index}
                                          index={data.r_index}
                                          filteredIndex={index}
                                          data={data}
                                          onTableRowMenuClick={handleTableRowMenuContent}
                                          isSelected={filteredReconIndex === index}
                                          isExpanded={expandedRowKey === rowKeyOf(data)}
                                          detail={rowDetail[rowKeyOf(data)]}
                                          onToggleExpand={handleToggleExpand}
                                          onRetryDetail={(d) => fetchRowDetail(rowKeyOf(d), d)}
                                       />
                                    ))
                                 ) : (
                                    <tr key="nr-rows">
                                       <td colSpan="12" className="text-center">
                                          No invoices found.
                                       </td>
                                    </tr>
                                 )}
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </Col>
               </Row>
            </div>
            {showReconcileInvoiceStatementModal && <ReconcileInvoiceStatementPdfModal isEdit={invoiceStatementIsEdit} imageData={imageData} propScale={1.0} filteredReconIndex={filteredReconIndex ?? 0} setfilteredReconIndex={setFilteredReconIndex} filteredRecon={filteredData} documentGrade={documentGrade} originalPageNumber={originalPageNumber} onCloseModal={handleReconcileInvoiceStatementModalClose} onUpdateReconData={handleUpdateReconData} onFollowUpStatusChange={handleFollowUpStatusChange} />}
            {showStatementPdfModal && imageData && <PdfModal imageData={imageData} propScale={1.0} docObj={{ name: `${selectedInvoiceStatementName || "Invoice Statement"}`, uploadOn: selectedInvoiceStatementDate || null, uploadBy: "" }} onCloseModal={handleStatementPdfModalClose} />}
            {showFollowup && (
               <FollowUpModal
                  key={`${followUpSupplierDetailID}-${followUpExternalSourceHeaderID}`}
                  sdId={followUpSupplierDetailID}
                  eshId={followUpExternalSourceHeaderID}
                  supplierInvoiceNumber={followUpSupplierInvoiceNumber}
                  externalInvoiceNumber={followUpExternalInvoiceNumber}
                  onFollowUpStatusChange={handleFollowUpStatusChange}
                  onCloseFollowUpModal={handleFollowUpModalClose}
               />
            )}
            {showAudit && auditFilteredRow && <ReconcileInvoiceStatementAuditModal filteredRecon={auditFilteredRow} onCloseModal={handleAuditModalClose} />}

            <Footer />
         </div>
      </>
   );
}
